






































































































































import { Vue, Component } from 'vue-property-decorator';
import businessLicense from 'assets/userCenter/authInfo/businessLicense.png';
import qualificationCertificate from 'assets/userCenter/authInfo/qualificationCertificate.png';
import honorCertificate from 'assets/userCenter/authInfo/honorCertificate.png';
import {
  getBusinessLicenseList,
  getQualificationList,
  delQualification,
  delHonor,
  getHonorList,
} from 'service/api';

interface BusinessLicenseRes {
  data: {
    picture: string;
  };
  state: boolean;
}

interface PictureRes {
  data: {
    rows: {id: string; picture: string}[];
  };
  state: boolean;
}

interface PictureItem {
  id: string;
  url: string;
}

@Component
export default class AuthInformation extends Vue {
  businessLicense: string = businessLicense;

  qualificationCertificate: string = qualificationCertificate;

  honorCertificate: string = honorCertificate;

  businessLicenseList: string[] = [];

  qualificationCertificateList: PictureItem[] = [];

  honorCertificateList: PictureItem[] = [];

  baseUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : '/';

  handleUploadSuccess(res: {state: boolean; message: string}) {
    if (res.state) {
      this.$message.success('上传成功');
    } else {
      this.$notify.error(res.message || '上传失败');
    }
  }

  handleUploadError() {
    this.$message.error('上传失败');
  }

  handleUploadLicenseSuccess(res: {state: boolean; message: string}) {
    this.handleUploadSuccess(res);
    this.getBusinessLicense();
  }

  handleQualificationSuccess(res: {state: boolean; message: string}) {
    this.handleUploadSuccess(res);
    this.getQualificationList();
  }

  handleHonorSuccess(res: {state: boolean; message: string}) {
    this.handleUploadSuccess(res);
    this.getHonorList();
  }

  async removeQualificationCertificate(id: string) {
    await delQualification(id);
    this.$message.success('删除成功');
    this.getQualificationList();
  }

  async removeHonorCertificate(id: string) {
    await delHonor(id);
    this.$message.success('删除成功');
    this.getHonorList();
  }

  async getBusinessLicense() {
    const res = await getBusinessLicenseList();
    if ((res as BusinessLicenseRes).data.picture) {
      this.businessLicenseList.splice(0, 1, (res as BusinessLicenseRes).data.picture);
    }
  }

  async getQualificationList() {
    const res = await getQualificationList();
    if ((res as PictureRes).state) {
      this.qualificationCertificateList = (res as PictureRes).data.rows.map(item => ({
        id: item.id,
        url: item.picture,
      }));
    }
  }

  async getHonorList() {
    const res = await getHonorList();
    if ((res as PictureRes).state) {
      this.honorCertificateList = (res as PictureRes).data.rows.map(item => ({
        id: item.id,
        url: item.picture,
      }));
    }
  }

  mounted() {
    this.getBusinessLicense();
    this.getQualificationList();
    this.getHonorList();
  }
}
